module.exports = __webpack_public_path__ + "static/media/Emblem_Bronze.c8cd6911.png";